import JSLoggerWrapper from "./JSLogger/JSLoggerWrapper";
import LoggingSource from "./LoggingSource";
import PinoLoggerWrapper from "./PinoLogger/PinoLoggerWrapper";

const defaultLogger = new JSLoggerWrapper();
// const defaultLogger = new PinoLoggerWrapper();
export default defaultLogger;
export { LoggingSource };
